module.exports = __webpack_public_path__ + "img/google play.93387845.svg";